module.exports = __webpack_public_path__ + "img/slider1.569b6da1.jpg";